import React from "react";
import ProfileComponent from "../components/ProfileComponent";

const Profile = () => {
  return <ProfileComponent />;
};

export default Profile;
